export default __webpack_public_path__ + "6919c3f8719ec0465c2b00dea77f09d7.png";